export class GetDomainKnowledgeItems {
  static readonly type = "[DomainKnowledge] Get domain items";
}
